import { merge } from "lodash";
import moment from "moment";
import { useRef } from "react";
import { BaseOptionChart } from "src/components/chart";

export default function useOptionsChart() {
	const lastCalculatedValueRef = useRef({});

	const options = merge(BaseOptionChart(), {
		chart: {
			animations: {
				enabled: true
			}
		},
		yaxis: {
			type: "numeric",
			min: 0,
			tickAmount: 4
		},
		xaxis: {
			type: "category",
			tickPlacement: "on",
			categories: moment.months().map((i) => i.charAt(0).toUpperCase() + i.slice(1))
		},
		tooltip: {
			intersect: false,
			shared: true
		},
		legend: {
			show: false
		},
		fill: {
			gradient: {
				opacityFrom: [0.4, 0, 0, 0, 0]
			}
		}
	});

	lastCalculatedValueRef.current = options;

	return {
		options
	};
}
